import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import useStore from '@hooks/useStore';

import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard';
import useStyles from './styles';
import { ICopyToClipboard } from './types';

const CopyToClipboard: React.FC<ICopyToClipboard> = ({ text, tooltipText, children }) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const {
    links: {
      coBrandingConfig: { primaryColor },
    },
  } = useStore();
  const css = useStyles({ primaryColor });
  const { t } = useTranslation();
  const copyTimer = React.useRef<number | null>(null);

  const clearCopyTimer = () => {
    if (copyTimer.current) {
      clearInterval(copyTimer.current);
    }
  };

  React.useEffect(() => {
    return () => clearCopyTimer();
  }, []);

  const onCopyHandler = (): void => {
    clearCopyTimer();
    setIsCopied(true);
    copyTimer.current = window.setTimeout(() => setIsCopied(false), 2000);
  };

  const CopyLinkMessage = () => (
    <Box display="flex" alignItems="center">
      {tooltipText || t('common.tooltip.copied')}
      <CheckCircleIcon fontSize="small" className={css.tooltipIcon} />
    </Box>
  );

  return (
    <Tooltip
      open={isCopied}
      arrow
      title={<CopyLinkMessage />}
      placement="top"
      classes={{
        tooltip: css.tooltip,
        arrow: css.arrow,
      }}
    >
      <ReactCopyToClipboard text={text} onCopy={onCopyHandler}>
        {children}
      </ReactCopyToClipboard>
    </Tooltip>
  );
};

export default CopyToClipboard;
